import * as types from "./types";
import {
  getWebsitebuildersAxios,
  getWebsitebuilderAxios,
  getWebsiteAxios,
  deleteWebsitebuildersAxios,
  postWebsitebuildersAxios,
  putWebsitebuildersAxios,
  getWebsitebuildersByIdAxios,
} from "./services";

export async function getWebsitebuildersListAction({ commit }) {
  commit(types.LOADING_WEBSITEBUILDERS, true);
  try {
    const { data } = await getWebsitebuildersAxios();
    commit(types.GET_WEBSITEBUILDERS_LIST, data.result.data);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_WEBSITEBUILDERS, false);
  }
}

export async function getWebsiteAction({ commit }) {
  commit(types.LOADING_WEBSITEBUILDERS, true);
  try {
    const { data } = await getWebsiteAxios();
    commit(types.GET_WEBSITE, data.result);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_WEBSITEBUILDERS, false);
  }
}

export async function getWebsitePageName({ commit }) {
  commit(types.LOADING_WEBSITEBUILDERS, true);
  try {
    const { data } = await getWebsitebuilderAxios();        
    commit(types.GET_WEBSITE, data);
    return data;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_WEBSITEBUILDERS, false);
  }
}


export async function getWebsitebuildersAction({ commit }, id) {
  commit(types.LOADING_WEBSITEBUILDERS, true);
  try {
    const { data } = await getWebsitebuildersByIdAxios(id);
    commit(types.GET_WEBSITEBUILDERS_BY_ID, data.result);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_WEBSITEBUILDERS, false);
  }
}

export async function removeWebsitebuildersAction({ commit }, payload) {
  commit(types.LOADING_WEBSITEBUILDERS, true);
  try {
    await deleteWebsitebuildersAxios(payload);
    commit(types.REMOVE_WEBSITEBUILDERS, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_WEBSITEBUILDERS, false);
  }
}

export async function addWebsitebuildersAction({ commit }, payload) {
  commit(types.LOADING_WEBSITEBUILDERS, true);
  try {
    await postWebsitebuildersAxios(payload);
    commit(types.ADD_WEBSITEBUILDERS, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_WEBSITEBUILDERS, false);
  }
}

export async function updateWebsitebuildersAction({ commit }, payload) {
  commit(types.LOADING_WEBSITEBUILDERS, true);
  try {
    await putWebsitebuildersAxios(payload);
    commit(types.UPDATE_WEBSITEBUILDERS, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_WEBSITEBUILDERS, false);
  }
}
